import { useInjectReducer, useInjectSaga } from "redux-injectors";
import saga from "./saga";
import { reducer } from "./slice";

export default function AnalyticsInjectors() {
  useInjectReducer({ key: "analytics", reducer });
  useInjectSaga({ key: "analytics", saga });
  return null;
}
